import Vue from 'vue'
import Router from 'vue-router'
import { h5Routes } from './h5'
import { pcRoutes } from './pc'
import { i18n } from '@/i18n'
import { DEFAULT_TITLE, pageTitles } from '@/i18n/pageTitles'

let isPhone = function() {
    let width = window.innerWidth;
    let flag = true;
    if (width < 800) {
        flag = false
    }
    return flag
};

let ispc = isPhone();

Vue.use(Router)

const router = new Router({
    routes: ispc ? pcRoutes : h5Routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition && to.meta.keepAlive) {
            return savedPosition;
        }
        return { x: 0, y: 0 };
    },

})

router.afterEach((to) => {
    const titleKey = pageTitles[to.name] || DEFAULT_TITLE
    document.title = i18n.t(titleKey) + ' | ' + i18n.t('丰派软件')
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js